/**
 * 多标签页登录态同步
 *
 * token 存在 localStorage、各标签页共用，但用户信息、权限菜单、IM 连接和各类缓存都在每个标签页自己的内存里。
 * 别的标签页退出或换账号登录后，本页仍按内存里上一个账号渲染，请求却已带上新 token，会出现新旧账号数据混显。
 * 这里监听其他标签页对 token 的改动并整页重载：没有 token 时由路由守卫送去登录页，有新 token 时按新账号重建全部状态。
 * 公开页面（登录页、访客聊天、聊天记录外链）不依赖登录态，不处理。
 */
import type { Router } from 'vue-router';
import { useUserStore } from '@/stores/user';

export function setupAuthSync(router: Router) {
  window.addEventListener('storage', (event) => {
    /** storage 事件只在其他标签页改动时触发；key 为 null 表示整个 localStorage 被清空 */
    if (event.storageArea !== localStorage) return;
    if (event.key !== null && event.key !== 'token') return;
    if (router.currentRoute.value.meta.public) return;
    /** 与本页内存中的 token 一致（如其他标签页重复写入同一值）时无需处理 */
    if ((localStorage.getItem('token') ?? '') === useUserStore().token) return;
    window.location.reload();
  });
}
